import ExtensionsMenuContent from './ExtensionsMenuContent';

export default ExtensionsMenuContent;
